/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomVersionRequest extends models.AppSecopsSbomVersionBase {
    getFixupPrototypeFunction() { return AppSecopsSbomVersionRequest.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomVersionRequest>): AppSecopsSbomVersionRequest {
        let obj = Object.assign(new AppSecopsSbomVersionRequest(), model);
        AppSecopsSbomVersionRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomVersionRequest>): AppSecopsSbomVersionRequest {
        if (!model) return null;
        return AppSecopsSbomVersionRequest.newInstance(<AppSecopsSbomVersionRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomVersionRequest) {
        if (!obj) return;

        models.AppSecopsSbomVersionRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomVersionRequest): boolean {
        if (models.AppSecopsSbomVersionBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsSbomVersionRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * If set true, allows version creation even if duplicate exists under tenant, false prevents duplicate creation
     */
    force: boolean;

}
